import axios from 'axios';
import CONFIG from '../config';
import Vue from 'vue'
/**
 * @param headers
 * @returns {Promise<any>|{newMember({name, email}): Promise<any>, transfer({to, amount, time, hasEscrow}): Promise<any>, voting({subject, description, endTime}): Promise<any>, notify({to, subject, text}): Promise<any>}}
 */
export function mails(headers) {
  return {
    /**
     * @param body {Object}
     * @param body.to {'agent'|'support'}
     * @param body.subject {string}
     * @param body.text {string}
     * @returns {Promise<any>}
     */
    notify(body) {
      return this._send(CONFIG.endPoints.mails.notify, body);
    },
    /**
     * @param body {Object}
     * @param body.name {string}
     * @param body.email {string}
     * @returns {Promise<any>}
     */
    newMember(body) {
      return this._send(CONFIG.endPoints.mails.newmember, body);
    },
    /**
     * @param body {Object}
     * @param body.name {string}
     * @param body.email {string}
     * @param body.address {string}
     * @param body.time {string}
     * @returns {Promise<any>}
     */
    approveNewMember(body) {
      return this._send(CONFIG.endPoints.mails.approveMember, body);
    },
    /**
     * @param body {Object}
     * @param body.subject {string}
     * @param body.description {string}
     * @param body.endTime {string}
     * @returns {Promise<any>}
     */
    voting(body) {
      return this._send(CONFIG.endPoints.mails.voting, body);
    },
    /**
     * @param body {Object}
     * @param body.subject {string}
     * @param body.resolveTime {string}
     * @returns {Promise<any>}
     */
    resolveVoting(body) {
      return this._send(CONFIG.endPoints.mails.resolveVoting, body);
    },
    /**
     * @param body {Object}
     * @param body.to {string}
     * @param body.amount {string}
     * @param body.time {string}
     * @param body.hasEscrow {boolean}
     * @returns {Promise<any>}
     */
    transfer(body) {
      return this._send(CONFIG.endPoints.mails.transfer, body);
    },
    /**
     * @param body {Object}
     * @param body.from {string}
     * @param body.to {string}
     * @param body.amount {string}
     * @param body.time {string}
     * @returns {Promise<any>}
     */
    agentTransfer(body) {
      return this._send(CONFIG.endPoints.mails.agentTransfer, body);
    },
    /**
     * @param body {Object}
     * @param body.to {string}
     * @param body.amount {string}
     * @param body.price {string}
     * @param body.time {string}
     * @param body.mode {number}
     * @param body.hasEscrow {boolean}
     * @returns {Promise<any>}
     */
    trade(body) {
      return this._send(CONFIG.endPoints.mails.trade, body);
    },
    /**
     * @param body {Object}
     * @param body.from {string}
     * @param body.to {string}
     * @param body.amount {string}
     * @param body.price {string}
     * @param body.time {string}
     * @param body.mode {number}
     * @returns {Promise<any>}
     */
    agentTrade(body) {
      return this._send(CONFIG.endPoints.mails.agentTrade, body);
    },
    /**
     * @param body {Object}
     * @param body.title {string}
     * @param body.time {string}
     * @returns {Promise<any>}
     */
    uploadFile(body) {
      return this._send(CONFIG.endPoints.mails.uploadFile, body);
    },
    /**
     * @param body {Object}
     * @param body.title {string}
     * @param body.time {string}
     * @returns {Promise<any>}
     */
    uploadLegal(body) {
      return this._send(CONFIG.endPoints.mails.uploadLegal, body);
    },
    /**
     * @param endpoint {string}
     * @param body {Object}
     * @returns {Promise<any>}
     * @private
     */
    _send(endpoint, body) {
      return new Promise((resolve, reject) => {
        axios
          .post(CONFIG.backendURL + endpoint, body, headers)
          .then(result => {
            resolve(result.data);
            Vue.toasted.success('Message successfully sent')
          })
          .catch(error => {
            Vue.toasted.error('Message has not been sent', error.response)
            reject(error.response);
          });
      });
    }
  };
}
